import { useLocation } from "react-router";

function useCheckIfLibrary() {
  const location = useLocation();
  return location.pathname.endsWith("/");
}

export default useCheckIfLibrary;
